const middleware = {}

middleware['isAuth'] = require('../website/middleware/isAuth.js')
middleware['isAuth'] = middleware['isAuth'].default || middleware['isAuth']

middleware['pageChange'] = require('../website/middleware/pageChange.ts')
middleware['pageChange'] = middleware['pageChange'].default || middleware['pageChange']

export default middleware
